<template>
   <div style="position: relative;">
      <div v-loading="loading" class="prism-player" id="player-con"></div>
   </div>
</template>

<script>
import FlvPlayer from "./component/FlvPlayer.vue";

export default {
   components: {
      FlvPlayer,
   },
   data () {
      return {
         // videoUrl: decodeURIComponent(this.$route.query.videoUrl),
         // videoUrl:
         //   "https://play.joyfinder.com.cn/CAIXUN_LIVE/replay_YP20250422001_123456789.m3u8?auth_key=1746584030-0-0-f4632eca6dd5dc2a662fc9ed3164302a",
         videoUrl: null,
         token: null,
         timer: null,
         player: null,
         loading: false
      };
   },
   async mounted () {
      try {
         this.token = this.$route.query.token;
         this.requestStreamParams = JSON.parse(
            decodeURIComponent(this.$route.query.videoParams)
         );
      } catch { }

      await this.getViedoUrl()
      this.searchState()

      // this.reLoadVideo(this.videoUrl)
      // setInterval(()=>{
      //   this.player && console.log(11111,this.player.getStatus());
      // },1000)

   },
   beforeDestroy () {
      this.timer && clearTimeout(this.timer);
   },
   methods: {
      async getViedoUrl () {
         this.loading = true
         await this.$axios({
            method: "post",
            url: "https://dm-console.joyfinder.com.cn/device/request_stream/",
            // url: "/api/device/request_stream/",
            headers: {
               'Authorization': this.token,
            },
            data: this.requestStreamParams,
         }).then(({ data }) => {
            this.videoUrl = data.data.play_url;
         }).catch(() => { }).finally(() => {
            this.loading = false
         })
      },
      // 查询推流状态 
      searchState () {
         this.loading = true
         this.timer = setInterval(() => {
            this.$axios({
               method: "HEAD",
               url: this.videoUrl,
            }).then((res) => {
               console.log(res, res.statusCode, "推流成功");
               if (res.status === 200) {
                  clearTimeout(this.timer);
                  this.reLoadVideo(this.videoUrl)
                  this.loading = false
               }
            });
         }, 1000);
      },
      reLoadVideo (url) {
         this.player && this.player.dispose()
         this.player = new Aliplayer(
            {
               id: "player-con",
               source: url,
               width: "100%",
               height: "70vw",
               autoplay: true,
               isLive: false,
               rePlay: true,
               videoHeight: undefined,
               isVBR: undefined,
               preload: true,
               enableStashBufferForFlv: true,
               stashInitialSizeForFlv: 32,
               controlBarVisibility: "hover",
               useH5Prism: true,
            },
            function (player) {
               console.log("The player is created");
            }
         );
      }
   },
};
</script>
<style lang="less">
.prism-license-watermark {
   display: none !important;
}

.prism-player {
   width: 100%;
   height: 70vw;
   background: #000;
}

/* 下载按钮样式，右上角悬浮 */
.download-btn {
   position: absolute;
   top: 6%;
   /* 上边距占父盒子高度的 2% */
   right: 6%;
   /* 右边距占父盒子宽度的 2% */
   width: 6%;
   /* 宽度占父盒子宽度的 6% */
   height: auto;
   /* 高度自动按宽度比例 */
   max-width: 50px;
   /* 最大宽度限制，防止电脑屏幕过大 */
   min-width: 24px;
   /* 最小宽度限制，防止手机屏幕过小 */
   cursor: pointer;
   z-index: 9999;
}
</style>